import { render, staticRenderFns } from "./DependentesFormModal.vue?vue&type=template&id=4bda804e&"
import script from "./DependentesFormModal.vue?vue&type=script&lang=js&"
export * from "./DependentesFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports